// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TA_rg","largestCol":"styles_largestCol__2WQBZ","smallestCol":"styles_smallestCol__2-CTA"};